export default "__VITE_ASSET__42939346__"